import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import registrationsAction from "../../../../../store/registrations/action";
import { RegisWizardSteps } from "../../../Helpers/LookUpValues";
import { EventDates } from "../../../formatEventDates";

const styles = {
  label: {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  title: {   
    fontWeight: 400,
    lineHeight: 1.35,
  },
  description: {
    fontSize: "0.95rem",
    fontWeight: 400,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
};

const Field = ({ label, value, valueStyle, colClass = "col-md-6" }) => (
  <div className={`${colClass} mb-3`}>
    <span className="text-muted d-block mb-1" style={styles.label}>
      {label}
    </span>
    <span className="text-secondary d-block" style={valueStyle || styles.value}>
      {value && String(value).trim() ? value : "N/A"}
    </span>
  </div>
);


class StepOne extends Component {
  render() {
    let idx = this.props.steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    const { currentStep } = this.props;
    if (currentStep !== idx) {
      // Prop: The current step
      return null;
    }
    const { selectedOpenRegRow } = this.props.registrationsState || {};
    const row = selectedOpenRegRow || {};
    return (
      // .box has a border but no padding, so pad here to keep the fields off it
      <div className="px-3 pt-3">
        <div className="row">
          <Field
            label="Title"
            value={row.title}
            valueStyle={styles.title}
            colClass="col-12"
          />
          <Field
            label="Description"
            value={row.description}
            valueStyle={styles.description}
            colClass="col-12"
          />
          <Field label="Dates" value={row.dates} />
          <Field label="Window" value={row.registrationWindow} />
          <Field label="Location" value={row.location} />
          <Field label="Category" value={row.category} />
        </div>
      </div>
    );
  }
}
export default withRouter(
  connect(
    (state) => ({
      registrationsState: state.registrations,
    }),
    {
      ...registrationsAction,
    }
  )(StepOne)
);
